import React, { useContext } from "react";
import MenuContainer from "../../components/MenuContainer/index.js";
import cdp_logo from "../../images/png/cdp_white_logo.png";
import { REDIRECT_LOGO } from "../../utils/redirectPaths";
import { Link } from "react-router-dom";
import { Layout, Avatar, Dropdown, Menu } from "antd";
import {UserOutlined} from "@ant-design/icons";
import {AppContext, logout} from "../App";
import "../../css/global.scss"

const  { Header, Sider, Content } = Layout;

const MainLayout = props => {
  const { children } = props;
  const context = useContext(AppContext);

  const accountMenu = (
    <Menu>
      <Menu.Item key="logout">
        <div onClick={logout}>Logout</div>
      </Menu.Item>
    </Menu>
  )

  return (
    <div className="MainLayout">
      <Header
        style={{
          background: "#5d86af",
          borderBottom: "1px solid black",
          position: "fixed",
          padding: "0 25px 0 25px",
          left: 0,
          top: 0,
          right: 0,
          height: 90,
          zIndex: 999
        }}
      >
        <Link to={REDIRECT_LOGO}>
          <img src={cdp_logo} alt="CDP_logo" style={{marginTop:"15px"}} width="108px"/>  
        </Link>
        <div style={{float: "right", marginTop: "5px"}}>
            <Dropdown overlay={accountMenu} placement="bottom">
              <Avatar style={{ backgroundColor: "#3e5364", cursor: "pointer" }} icon={<UserOutlined/>} />
            </Dropdown>
            <div style={{marginTop: "18px",float: "right",height: "30px", lineHeight: "2px", padding: "0", marginLeft: "10px" , color: "#ffffff"}}>
              <p><b>{context.username}</b></p>
              <p>{context.email}</p>
              <p>{new Date().toDateString()}</p>
            </div>
        </div>
      </Header>
      <Layout>
        <Sider
          width="260"
          theme="dark"
          style={{
            borderRight: "1px solid black",
            overflow: "auto",
            height: "100vh",
            position: "fixed",
            left: 0,
            top: 90,
            marginRight: 5,
            zIndex: 1
          }}
        >
        <MenuContainer />
        </Sider>
        <Layout style={{ marginLeft: 260, padding: "0 5px", background: "#fff" }}>
          <Content
            style={{
              background: "#fff",
              marginTop: 100,
              padding: 40,
              minHeight: "calc(100vh - 64px)",
              minWidth: 0,
              overflow: "auto"
            }}>
            {children}
          </Content>
        </Layout>
      </Layout>
    </div>
  );
};

export default MainLayout;
